import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('VersioningService', VersioningService);

  VersioningService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'VersioningModalService',
    'WindowModalService',
  ];

  // export function VersioningService(
  function VersioningService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    VersioningModalService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'versionings';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getAppVersions: getAppVersions,
      getAppVersion: getAppVersion,
      saveAppVersion: saveAppVersion,
      openAppVersionModal: openAppVersionModal,
      openUpdateUserAppVersionModal: openUpdateUserAppVersionModal,
      getCurrentAppVersion: getCurrentAppVersion,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'desc',
        sortedBy: 'created_at',
      };

      return filterCriteria;
    }

    function getAppVersions(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getAppVersion(id, language) {
      var params = {
        lang: null,
      };

      if (language) {
        params.lang = language;
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveAppVersion(appVersion) {
      // translations language
      var url = apiUrl;
      var method = 'post';

      if (appVersion.id) {
        // edit
        url += '/' + appVersion.id;
        method = 'put';
      }

      // var lang = (language) ? language : config.DEFAULT_CONTENT_LANGUAGE; // lang: lang

      return RestResource.request(
        method,
        url,
        { versioning: appVersion },
        function (response) {
          var msg = !appVersion.id ? 'APP_VERSION_ADDED' : 'APP_VERSION_MODIFIED';
          utils._successMsg($translate(msg));

          return response.data;
        },
        function (response) {
          return response.data;
        }
      );
    }

    function openAppVersionModal(
      appVersion,
      additionalLanguages,
      mode,
      successCallback,
      currentAppVersion
    ) {
      var getItem = function (data) {
        var templateUrl = './app/ajs/admin/versioning/modals/versioning-detail-modal.html';

        var originalItem = angular.copy(data);

        var title = data.id ? 'APP_VERSION_DETAILS' : 'ADD_APP_VERSION';

        var modalParams = {
          title: title,
          item: originalItem,
          mode: mode,
          additionalLanguages: additionalLanguages,
          additionalParams: currentAppVersion,
          preventModalClose: true,
        };

        var confirmCallback = function (response) {
          if (data.id) {
            // Edit
            data.version_number = response.version_number;
            data.description = response.description;

            return utils.itemListChanged(response.id);
          }

          return successCallback(response);
        };

        WindowModalService.open(templateUrl, modalParams, confirmCallback);
      };

      if (!appVersion.id) {
        getItem(appVersion);
      } else {
        this.getAppVersion(appVersion.id).then(function (data) {
          getItem(data);
        });
      }
    }

    function openUpdateUserAppVersionModal(currentUserId) {
      VersioningModalService.openUpdateUserAppVersionModal(currentUserId);
    }

    function getCurrentAppVersion(language) {
      var params = {
        lang: null,
      };

      if (language) {
        params.lang = language;
      }

      return RestResource.request(
        'get',
        apiUrl + '/current_app_version',
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }
  }
})();
